// Off-canvas at full tap-target size until keyboard focus, same fix and same
// reasoning as the original site's scripts/export-transform.mjs: a 1x1 hidden
// link still trips an automated tap-target check, so this sits at -9999px
// with a real 44x44 box instead of collapsing to nothing.
export function SkipLink() {
  return (
    <a
      href="#main"
      className="absolute -left-[9999px] top-0 z-[80] min-h-11 min-w-11 rounded-sm bg-flow px-5 py-3 font-semibold text-n-100 focus:left-5 focus:top-5"
    >
      Skip to content
    </a>
  )
}
